import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FAQ({ faqList, theme }: any) {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('shared.product.support');
    const [type, setType] = useState('PRODUCT_RELATED'); // NOTE , FAULT
    const introductionList = faqList?.filter((faq: any) => faq.typeTag === 'PRODUCT_RELATED');
    const troubleshootingList = faqList?.filter((faq: any) => faq.typeTag === 'FAULT' || faq.typeTag.toUpperCase() === 'TROUBLESHOOTING');
    const noteList = faqList?.filter((faq: any) => faq.typeTag === 'NOTE');
    const [finalList, setFinalList] = useState(
        introductionList?.length > 0 ? introductionList : troubleshootingList?.lenght > 0 ? troubleshootingList : noteList?.length > 0 ? noteList : [],
    );
    const tabs: any[] = [];
    if (introductionList?.length) tabs.push({ key: 'PRODUCT_RELATED', value: t('faq_introduction') });
    if (troubleshootingList?.length) tabs.push({ key: 'TROUBLESHOOTING', value: t('faq_trouble') });
    if (noteList?.length) tabs.push({ key: 'NOTE', value: t('faq_note') });

    const handleClickTab = (key: string) => {
        if (window?.innerWidth < 768) {
            const target = document.querySelector('.product-support-faq .tabs') as HTMLElement;
            if (target) {
                if (['TROUBLESHOOTING', 'NOTE'].includes(key)) {
                    target.scrollLeft = target.scrollWidth - window?.innerWidth > 0 ? target.scrollWidth - window?.innerWidth : 0;
                } else {
                    target.scrollLeft = 0;
                }
            }
        }
        setType(key);
    };

    useEffect(() => {
        const introductionList = faqList?.filter((faq: any) => faq.typeTag === 'PRODUCT_RELATED');
        const troubleshootingList = faqList?.filter((faq: any) => faq.typeTag === 'FAULT' || faq.typeTag.toUpperCase() === 'TROUBLESHOOTING');
        const noteList = faqList?.filter((faq: any) => faq.typeTag === 'NOTE');
        if (introductionList?.length > 0) {
            setType('PRODUCT_RELATED');
        } else {
            if (troubleshootingList?.length > 0) {
                setType('TROUBLESHOOTING');
            } else if (noteList?.length > 0) {
                setType('NOTE');
            }
        }
    }, [faqList]);

    useEffect(() => {
        setFinalList(type === 'PRODUCT_RELATED' ? introductionList : type === 'TROUBLESHOOTING' ? troubleshootingList : type === 'NOTE' ? noteList : []);
    }, [type]);

    return (
        <section className={`product-support-faq ${css['product-support-faq']} ${theme}`}>
            <ul className="tabs">
                {tabs?.map((tab: any, _k: number) => (
                    <li className={`tab ${type === tab?.key ? 'active' : ''}`} key={tab?.key} onClick={() => handleClickTab(tab?.key)}>
                        {tab?.value}
                    </li>
                ))}
            </ul>
            {finalList?.length > 0 && (
                <Collapse
                    ghost={true}
                    className="collapse-lists-faq"
                    defaultActiveKey={0}
                    // onChange={setActive}
                    // accordion={true}
                    expandIcon={({ isActive }: any) => {
                        return (
                            <svg
                                className={`collapse-icon ${isActive ? 'active' : ''}`}
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                            >
                                <path
                                    d="M17.5 15L12.5 10L7.5 15"
                                    stroke={theme === 'white' ? 'black' : 'white'}
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        );
                    }}
                    expandIconPosition="right"
                >
                    {finalList?.map((list: any, k: number) => (
                        <Collapse.Panel className="list-title" key={k} header={list.title}>
                            <p className="list-desc">{list.description}</p>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            )}
        </section>
    );
}
